import { Injectable } from '@angular/core';
import { LogLevel } from './log-level';
import { LogPublisher } from './log-publisher';
import { LogPublisherService } from './log-publisher.service';
import { LogEntry } from './log-entry.model';
import { SharedConfig } from './shared-config';

@Injectable({
    providedIn: 'root'
})
export class LogService {

    logLevel: LogLevel = LogLevel.All;
    logPublishers: LogPublisher[] = [];
    
    constructor(_publisherService: LogPublisherService, _sharedConfig: SharedConfig) {
        this.logPublishers = _publisherService.publishers;
        this.logLevel = _sharedConfig.logLevel;
    }

    debug(message: string) {
        this.writeToLog(message, LogLevel.Debug);
    }

    info(message: string) {
        this.writeToLog(message, LogLevel.Info);
    }

    warn(message: string) {
        this.writeToLog(message, LogLevel.Warn);
    }

    error(message: string) {
        this.writeToLog(message, LogLevel.Error);
    }

    fatal(message: string) {
        this.writeToLog(message, LogLevel.Fatal);
    }

    log(message: string) {
        this.writeToLog(message, LogLevel.All);
    }

    private writeToLog(message: string, level: LogLevel) {
        if (this.shouldLog(level)) {
            let entry: LogEntry = new LogEntry();
            entry.message = message;
            entry.level = level;
            for (let logPublisher of this.logPublishers) {
                logPublisher.log(entry);
            }
        }
    }

    private shouldLog(level: LogLevel): boolean {
        return (level >= this.logLevel && level !== LogLevel.Off) || this.logLevel === LogLevel.All;
    }
}
